import React from "react";
import styles from "./MobileAccordionContainer.module.scss";

interface MobileAccordionContainerProps {
  children: React.ReactNode;
}

export const MobileAccordionContainer: React.FC<
  MobileAccordionContainerProps
> = ({ children }) => {
  return <div className={styles.mobileAccordionContainer}>{children}</div>;
};
